import OnboardOrganizationDetails from '../../views/OnboardOrganizationDetails';

export default function OnboardOrganizationDetailsPage() {
  return (
    <>
      <OnboardOrganizationDetails />
    </>
  );
}

